<template>

  <div class="footer">
    <div class="foot_Title">
      <span>{{$t('language.my')}}</span>
    </div>
    <div class="line"></div>
    <div class="content">

      <div class="labelT" v-for="(item,index) in detailList" :key="index">
		 <div class="sign_t " v-if="item.is_required == 1">
		 	必填
		 </div>
		 <div class="sign_t " v-if="item.is_required == 0">
			 选填
		 </div>
        <div class="labelS">
          <span v-if="lang == 'cn'">{{item.field_title}} </span>
          <span v-else>{{item.field_title_en}}</span>
        </div>
        <div class="input"  style="color: #000000;" v-if="item.field_type == 'select'">
          <el-select  :disabled="disabled" v-model="item.field_value" clearable  :placeholder="$t('language.place')">
            <el-option  v-for="(ite,index) in item.field_option" :key="index" :label="ite" :value="ite">
            </el-option>
          </el-select>
		<!--  <el-select v-else :disabled="disabled" v-model="item.field_value" clearable  :placeholder="$t('language.place')">
		    <el-option  v-for="(ite,index) in item.field_option_en" :key="index" :label="ite" :value="ite">
		    </el-option>
		  </el-select> -->
        </div>
        <div class="input" v-if="item.field_type == 'input'">
          <el-input :disabled="disabled" v-model="item.field_value"></el-input>
        </div>
        <div class="sign_type" :class="{textare:item.field_type == 'textarea'}" v-if="item.field_type == 'textarea'">
          <textarea rows="3" :disabled="disabled" style="resize: none;" v-model="item.field_value" cols="20">
            </textarea>
        </div>
        <div class="sign_type" :class="{audios:item.field_type == 'radio'}" v-if="item.field_type == 'radio'">
          <div class="audio">
            <el-radio v-model="item.field_value" v-for="(ite,ind) in item.field_option" :key="ind" :label="ite">{{ite}}</el-radio>

          </div>
        </div>
        <div class="sign_type" :class="{audios:item.field_type == 'checkbox'}" v-if="item.field_type == 'checkbox'">
          <div class="audio">
            <el-checkbox-group :disabled="disabled" v-model="values">
              <el-checkbox :label="ite" v-for="(ite,ind) in item.field_option" :key="ind" @change="valueChange($event,item,ind,index)">{{ite}}</el-checkbox>
            </el-checkbox-group>
          </div>
        </div>

        <div class="sign_type" v-if="item.field_type == 'date'">
          <el-date-picker :disabled="disabled" v-model="item.field_value" type="date" @change="dateChange($event,item,index)"
            placeholder="选择日期">
          </el-date-picker>
        </div>

        <input ref="filElem" type="file" class="uploads-file" @change="getFile" style="display: none;">
        <div v-if="item.field_type == 'image'">
          <div class="upoadImas" v-if="headerImage" @click="uploadHead">
            <img :src="headerImage" alt="">
          </div>
          <div class="upoadImas" v-else @click="uploadHead">
            <img src="../assets/image/upload.png" alt="">
          </div>
        </div>



        <!-- <input ref="filElem" type="file" class="uploads-file" @change="getFile" style="display: none;"> -->

        <!-- 单摄影师 -->
        <input ref="fileImage" multiple type="file" class="uploads-file" @change="getImageFile" style="display: none;">
        <div class="is_set" v-if="item.field_type == 'single'">
          <div class="imageList" v-for="(it,ins) in item.field_value" :key="ins">
            <img :src="it.file_path" alt="">
            <div class="close" @click="closeEvent(index,ins ,it)">
              <img src="../assets/image/close.png" alt="">
            </div>
          </div>
          <div class="images" @click="uploadIma()">
            <img src="../assets/image/add.png" alt="">
          </div>
		  <div class="clear"></div>
        </div>

        <!-- 上传视频 -->
        <input ref="fileVideo" type="file" class="uploads-file" @change="getVideoFile" style="display: none;">
        <div class="is_set" v-if="item.field_type == 'video'">
          <div class="imageList" v-for="(it,ins) in item.field_value" :key="ins">
            <video v-if="it.file_type == 'video'" width="100%" height="100%" :src="it.file_path" controls="controls"></video>
			<img v-if="it.file_type == 'image'" :src="it.file_path" width="100%" height="100%"></img>
            <div class="close" @click="closeEvent(index,ins ,it)">
              <img src="../assets/image/close.png" alt="">
            </div>
          </div>
          <div class="images" @click="uploadVideo()">
            <img src="../assets/image/add.png" alt="">
          </div>
		  <div class="clear"></div>
        </div>


        <div class="is_set" v-if="item.field_type == 'multiple'">
          <div class="listT" v-for="(ite,ind) in item.field_value" :key="ind" @click="listEvent(ite.id)">
            <span>{{ite.name}}</span>
            <div class="closeO" @click.stop="closeTab(ite.id)">
              <img src="../assets/image/close.png" alt="">
            </div>
          </div>

          <div class="addTab" v-if="detail.audit_status == 2 || detail.audit_status == -1" @click="addEvent">
            <span>添加</span>
          </div>
		  <div class="clear"></div>
        </div>
      </div>

	<div style="height: 50px;"></div>
      <div class="labelT" v-if="detail.audit_status == 2">
        <div class="labelS">
          <span>驳回原因</span>
        </div>
        <div class="input bohui_input">
          <span>{{detail.audit_fail_opinion}}</span>
        </div>
      </div>
    </div>
    <div class="clear"></div>
    <div class="submit" v-if="detail.audit_status == 2 || detail.audit_status == -1">
      <div class="closeList" @click="closesign">
        <span>{{$t('language.Delete')}}</span>
      </div>
      <div class="submitBtn" @click="submitBtn()">
        <span>{{$t('language.Modify')}}</span>
      </div>
    </div>
    <div style="height: 200px;"></div>
    <addphotographer :exhibitionid="exhibition_apply_id" :isFlag="true" :details="details" :addShow="addShow" :dataList="dataList"
      :showId="showId" @baseEvent="baseEvent"></addphotographer>
  </div>
</template>

<script>
  import addphotographer from '../components/addphotographer'
  export default {
    components: {
      addphotographer
    },
    data() {
      return {
        imageUrl: require('../assets/image/banner1.png'),
        imageUl: '',
        disabled: true,
        form: {
          type: '',
          selectValue: '',
          name: '',
          sex: '',
          image: '',
          province: '',
          identity: '',
          phone: '',
          email: '',
          userName: ''
        },
		headerImage:'',
        details: {},
        banjiShow: true,
        isEditPhotographer: false,
        dataList: {},
        values: [],
        options: [{
          value: '选项1',
          label: '黄金糕'
        }, {
          value: '选项2',
          label: '双皮奶'
        }, {
          value: '选项3',
          label: '蚵仔煎'
        }, {
          value: '选项4',
          label: '龙须面'
        }, {
          value: '选项5',
          label: '北京烤鸭'
        }],
        tablist: [],
        uploadImage: [],
        detailList: [],
        imageList: [],
        exhibition_apply_id: '',
        addShow: false,
        showId: 0,
        lang:'cn',
        detail: {}
      }
    },
    created() {
		
      if(localStorage.getItem('languageSet') == 'en'){
        this.lang = 'cn'
      }else{
        this.lang = 'en'
      }
	  console.log(this.lang)
      this.ajaxFun();
    },
    methods: {
      ajaxFun() {
        this.exhibition_apply_id = this.$route.query.id;
        var data = {
          id: this.$route.query.id
        }
        console.log('11123')
        this.$post('/Apply/detail', data).then(res => {
          this.detailList = res.data.fieldList
          this.detail = res.data.detail
		this.detailList.forEach(item => {
			if(item.field_name == 'photo_url'){
				if(item.field_value){
					this.headerImage = item.field_value
				}
			}
		})
          if (this.detail.audit_status == 2 || this.detail.audit_status == -1) {
            this.disabled = false;
          } else {
            this.disabled = true;
          }

          // for (var i = 0; i < this.detailList.length; i++) {
          //   if (this.detailList[i].field_type == 'single') {
          //     console.log(this.detailList[i].field_value);
          //     var arr = []
          //     arr.push(JSON.parse(this.detailList[i].field_value));
          //     this.detailList[i].field_value = arr;
          //   }
          //   if (this.detailList[i].field_type == 'checkbox') {
          //     this.values = this.detailList[i].field_value
          //   }
          // }
        })
      },

      closesign() {
        var data = {
          id: this.$route.query.id
        }

        this.$fetch('/Apply/del', data).then(res => {
          if (res.code == 200) {
            this.$message.success('删除成功');
            this.$router.push('/personal')
          }
        })
      },
      getFile(el) {
		  let that = this;
        var file = el.target.files[0];
        var blob = new Blob([file]);
        const blobUrl = window.URL.createObjectURL(blob);
        let formData = new FormData();
        formData.append('file', file);
        var data = formData;
        this.$post('/Upload/image', data).then(res => {
			this.$nextTick(function(){
				this.detailList.forEach(item => {
				  if (item.field_type == 'image') {
							  that.headerImage = res.data.file_path;
				    item.field_value = res.data.file_path;
				  }
				})
			})
        })

      },
      uploadHead() {
        console.log(this.detail.audit_status);
        if(this.detail.audit_status == 2 || this.detail.audit_status == -1){
          this.$refs.filElem[0].dispatchEvent(new MouseEvent('click'))
        }else{
          this.$message.error(this.$t('language.upload'))
        }
      },
      uploadIma() {
        if (this.detail.audit_status == 2 || this.detail.audit_status == -1) {
          this.$refs.fileImage[0].dispatchEvent(new MouseEvent('click'))
        } else {
          this.$message.error(this.$t('language.upload'))
        }
      },
      getImageFile(el) {
        var file = el.target.files;
        var flag = true;
        for (var i = 0; i < file.length; i++) {
          let formData = new FormData();
          formData.append("file", file[i]);
          var data = formData;
          if (file[i].type != 'video/mp4') {
            this.$post('/Upload/image', data).then(res => {
              this.detailList.forEach(item => {
                if (item.field_type == 'single') {
                  if (!item.field_value) {
                    item.field_value = [];
                  }
                  item.field_value.push(res.data);
                }
              })
            })
          } else {
            flag = false;
          }
        }
        if (!flag) {
          this.$message.error('当前只支持上传图片')
        }
      },
      getVideoFile(el) {
        if (this.detail.audit_status == 2 || this.detail.audit_status == -1) {
          var file = el.target.files[0];
          var blob = new Blob([file]);
          const blobUrl = window.URL.createObjectURL(blob);
          if (file.type == 'video/mp4') {
            let formData = new FormData();
            formData.append("file", file);
            var data = formData;
            this.$post('/Upload/video', data).then(res => {
              this.detailList.forEach(item => {
                if (item.field_type == 'video') {

                  // that.hackReset = false
                  // that.$nextTick(() => {
                  //   that.hackReset = true
                  //   that.most[index].field_value = obj
                  // })
                  item.field_value.push(res.data)
                }
              })
              console.log(this.detailList)
            })
          } else {
            this.$message.error(this.$t('language.uploadVideo'))
          }
        }

      },
      uploadVideo() {
        if (this.detail.audit_status == 2 || this.detail.audit_status == -1) {
          this.$refs.fileVideo[0].dispatchEvent(new MouseEvent('click'))
        } else {
          this.$message.error(this.$t('language.upload'))
        }
      },
      valueChange(e, item, index, inde) {
        for (var i = 0; i < this.detailList.length; i++) {
          if (this.detailList[i].field_type == 'checkbox') {
            this.detailList[i].field_value = this.values;
          }
        }
      },
      closeEvent(index, ins, it) {
        console.log('123212312')
        if (this.detail.audit_status == 2 || this.detail.audit_status == -1) {
          console.log(ins)
          // this.detailList[index].field_value(ins,1)
          this.detailList[index].field_value.splice(ins, 1)
          this.$fetch('Apply/delWork',{id:this.detailList[index].field_value[ins].id}).then(res=>{
            console.log(res);
          })
          console.log(this.detailList[index].field_value)
        } else {
          this.$message.error(this.$t('language.del'))
        }
      },
	  
	  dateChange(e, item, index) {
	  	console.log(e.getDate())
	  	const resDate = e.getFullYear() + '-' + (e.getMonth() + 1 < 10 ? '0' +( e.getMonth() + 1) : e.getMonth() + 1) + '-' + (e.getDate() < 10 ? '0' + e.getDate() : e.getDate())
	  	console.log(resDate);
	  	item.field_value = resDate;
	  },
      addEvent() {
        this.isEditPhotographer = false;
        this.dataList = [];
        this.addShow = true;
        this.ajaxFun();
      },
      parentEvent(data) {
        this.addShow = data;
        console.log(this.addShow)
        return
        this.ajaxFun();
      },
      baseEvent(data) {
        this.tablist = data;
        this.formList.forEach(item => {
          if (item.field_type == 'multiple') {
            item.field_value = '1';
          }
        })
      },
      closeTab(id) {
        if (this.detail.audit_status == 2 || this.detail.audit_status == -1) {
          var data = {
            id: id
          }
          var that = this;
          this.$fetch('/Apply/delPhotographer', data).then(res => {
            if (res.code == 200) {
              this.$message.success(res.message)
              that.ajaxFun()
            }
          })
        } else {
          this.$message.error('无法删除')
        }
      },
      listEvent(id) {
        this.details = this.detail;

        this.isEditPhotographer = true;
        this.showId = id;
        var data = {
          id: this.showId
        }
        this.$post('/Apply/photographerDetail', data).then(res => {
          this.dataList = res.data;
        })

        this.addShow = true;
      },
      submitBtn() {
        var that = this;
        console.log(that)
        var types = 'single'
        var data_s = JSON.parse(JSON.stringify(this.detailList));
        data_s.forEach(item => {
     
          if (item.field_type == 'video') {
            console.log(item.field_value);
          }
          if (item.field_name == 'single') {
            types = 'single'
            item.field_value = JSON.parse(JSON.stringify(item.field_value));
          } else {
            types = 'multiple'
          }
        })
		
		var lang = 'cn'
		var langSet = window.localStorage.getItem('languageSet');
		if(langSet == 'zh'){
			lang = 'en'
		}else{
			lang = 'cn'
		}
		console.log(data_s,'12333222');
		// 校验参数是否为空
		var string = '';
		
		for(var i = 0; i < data_s.length; i++){
			if(data_s[i].is_required == 1){
				if(!data_s[i].field_value){
					if(lang == 'cn'){
						string = data_s[i].field_title;
					}else{
						string = data_s[i].field_title_en;
					}
					break; // 如果参数为空 跳出循环 提示
				}
			}
		}
		
		if(string != ''){
			if(lang == 'cn'){
				this.$message.error(`${string}不能为空`);
			}else{
				this.$message.error(`${string}Cannot be empty`);
			}
			return
		}
		
		console.log(data_s)
        var datas = JSON.stringify(data_s);
        var data = {
          id: this.$route.query.id,
          exhibition_category_id: this.detail.exhibition_category_id,
          ex_field_list: datas,
          photographer_type: types,
          audit_status: 0
        }
        this.$post('/Apply/save', data).then(res => {
          if (res.code == 200) {
            this.$router.push({
              path: '/personal'
            })
            this.$message.success('修改成功');

          }
        })
      }
    }
  }
</script>

<style scoped="scoped">
  @import url("../assets/css/modify.css");
</style>



// WEBPACK FOOTER //
// src/pages/modify.vue